"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on Tue Oct 16 2018
 */

var typescript_ioc_1 = require("@logio/typescript-ioc");

var EntityStateFlag_1 = require("../../core/model/EntityStateFlag");

var index_1 = require("../../core/utils/index");

var UserInfoConverter_1 = require("../../user/conversions/UserInfoConverter");

var MemberCredits_1 = require("../../window/model/MemberCredits");

var WindowItem_1 = require("../model/WindowItem");

var WindowItemWarningFlag_1 = require("../model/WindowItemWarningFlag");

var CoordinatorFlagsConverter_1 = require("./CoordinatorFlagsConverter");

var MemberCreditsConverter_1 = require("./MemberCreditsConverter");

var WindowItemConverter_1 = require("./WindowItemConverter");

var WindowItemPosAttributesConverter_1 = require("./WindowItemPosAttributesConverter");

var WindowItemSimulationConverter_1 = require("./WindowItemSimulationConverter");

var WindowItemSitesDataConverter_1 = require("./WindowItemSitesDataConverter");
/**
 * Default implementation of WindowItemConverter.
 *
 * @author JMt
 */


var WindowItemConverterImpl =
/*#__PURE__*/
function (_WindowItemConverter_) {
  _inherits(WindowItemConverterImpl, _WindowItemConverter_);

  function WindowItemConverterImpl(windowItemSimulationConverter, windowItemPosAttributesConverter, windowItemSitesDataConverter, memberCreditsConverter, userInfoConverter, coordinatorFlagsConverter) {
    var _this;

    _classCallCheck(this, WindowItemConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WindowItemConverterImpl).call(this));
    _this.windowItemSimulationConverter = windowItemSimulationConverter;
    _this.windowItemPosAttributesConverter = windowItemPosAttributesConverter;
    _this.windowItemSitesDataConverter = windowItemSitesDataConverter;
    _this.memberCreditsConverter = memberCreditsConverter;
    _this.userInfoConverter = userInfoConverter;
    _this.coordinatorFlagsConverter = coordinatorFlagsConverter;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(WindowItemConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      var _this2 = this;

      return new WindowItem_1.WindowItem(WindowItem_1.WindowItem.schema.id.valueOf(conversions.documentToClassId(source)), WindowItem_1.WindowItem.schema.productId.valueOf(conversions.toClassReferenceId(source.productId)), WindowItem_1.WindowItem.schema.windowId.valueOf(conversions.toClassReferenceId(source.windowId)), WindowItem_1.WindowItem.schema.externalId.valueOfField(source), WindowItem_1.WindowItem.schema.promotionId.valueOf(conversions.toClassReferenceId(source.promotionId)), WindowItem_1.WindowItem.schema.promoPrice.valueOf(conversions.toBigNumber(source.promoPrice)), WindowItem_1.WindowItem.schema.regularPrice.valueOf(conversions.toBigNumber(source.regularPrice)), WindowItem_1.WindowItem.schema.optRegularPrice.valueOf(index_1.Utils.isValueMissing(source.optRegularPrice) ? null : conversions.toBigNumber(source.optRegularPrice)), WindowItem_1.WindowItem.schema.cmForecast.valueOf(index_1.Utils.isValueMissing(source.cmForecast) ? null : conversions.toBigNumber(source.cmForecast)), WindowItem_1.WindowItem.schema.systemVolume.valueOf(index_1.Utils.isValueMissing(source.systemVolume) ? null : conversions.toBigNumber(source.systemVolume)), WindowItem_1.WindowItem.schema.lastSystemVolumeUpdate.valueOf(index_1.Utils.isValueMissing(source.lastSystemVolumeUpdate) ? null : source.lastSystemVolumeUpdate), WindowItem_1.WindowItem.schema.promoVolume.valueOf(conversions.toBigNumber(source.promoVolume)), WindowItem_1.WindowItem.schema.regularVolume.valueOf(index_1.Utils.isValueMissing(source.regularVolume) ? null : conversions.toBigNumber(source.regularVolume)), WindowItem_1.WindowItem.schema.requestSecondaryPlacement.valueOfField(source), WindowItem_1.WindowItem.schema.secondaryPlacement.valueOfField(source), conversions.asObject(source, 'posAttributes', this.deserializePosAttributes(conversions)), index_1.Utils.isValueMissing(source.memberCredits) ? MemberCredits_1.MemberCredits.EMPTY : conversions.asObject(source, 'memberCredits', this.deserializeMemberCredits(conversions)), WindowItem_1.WindowItem.schema.logisticComment.valueOfField(source), WindowItem_1.WindowItem.schema.returnable.valueOfField(source), WindowItem_1.WindowItem.schema.returnableCondition.valueOfField(source), WindowItem_1.WindowItem.schema.endDateOfReturn.valueOfField(source), WindowItem_1.WindowItem.schema.distrModelId.valueOf(conversions.toClassReferenceId(source.distrModelId)), WindowItem_1.WindowItem.schema.lastDistrModelIdChangeTime.valueOfField(source), WindowItem_1.WindowItem.schema.lastDistrModelIdChangeUser.valueOfField(source), WindowItem_1.WindowItem.schema.distributionModelDays.valueOfField(source), WindowItem_1.WindowItem.schema.lockType.valueOfField(source), WindowItem_1.WindowItem.schema.selloutSales.valueOfField(source), WindowItem_1.WindowItem.schema.ignoreForTraining.valueOfField(source), WindowItem_1.WindowItem.schema.activeSale.valueOfField(source), WindowItem_1.WindowItem.schema.extraSaleSticker.valueOfField(source), WindowItem_1.WindowItem.schema.tastings.valueOfField(source), WindowItem_1.WindowItem.schema.tvCommercial.valueOfField(source), WindowItem_1.WindowItem.schema.groupOfSitesId.valueOf(conversions.toClassReferenceId(source.groupOfSitesId)), WindowItem_1.WindowItem.schema.sitesData.valueOf(conversions.asObject(source, 'sitesData', function (obj) {
        return _this2.windowItemSitesDataConverter.toObject(obj, conversions);
      })), WindowItem_1.WindowItem.schema.onPicture.valueOfField(source), conversions.asFlagSet(source.stateFlags, EntityStateFlag_1.EntityStateFlag), source.classification, conversions.asFlagSet(source.warningFlags, WindowItemWarningFlag_1.WindowItemWarningFlag), WindowItem_1.WindowItem.schema.substituteProductId.valueOf(index_1.Utils.isValueMissing(source.substituteProductId) ? null : conversions.toClassReferenceId(source.substituteProductId)), WindowItem_1.WindowItem.schema.marketingComment.valueOfField(source), WindowItem_1.WindowItem.schema.directDelivery.valueOfField(source), WindowItem_1.WindowItem.schema.directDeliverySites.valueOfField(source), WindowItem_1.WindowItem.schema.measureUnits.valueOf(conversions.toClassReferenceId(source.measureUnits)), conversions.asObjectOpt(source, 'simulation', this.deserializeSimulation(conversions)), WindowItem_1.WindowItem.schema.justInTime.valueOf(source.justInTime ? source.justInTime : false), index_1.Utils.isValueMissing(source.processed) ? false : WindowItem_1.WindowItem.schema.processed.valueOfField(source), WindowItem_1.WindowItem.schema.lastPromoVolumeUpdate.valueOf(index_1.Utils.isValueMissing(source.lastPromoVolumeUpdate) ? null : conversions.toDate(source.lastPromoVolumeUpdate)), WindowItem_1.WindowItem.schema.lastSystemVolumeComputationFailure.valueOf(index_1.Utils.isValueMissing(source.lastSystemVolumeComputationFailure) ? null : conversions.toDate(source.lastSystemVolumeComputationFailure)), conversions.asObjectOpt(source, 'forecastCoordinatorFlag', this.deserializeCoordinator(conversions)), WindowItem_1.WindowItem.schema.snapshotOriginId.valueOf(conversions.toClassReferenceId(source.snapshotOriginId)), WindowItem_1.WindowItem.schema.source.valueOfField(source));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var _this3 = this;

      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, conversions.classToDocumentId(source));
      Object.assign(result, {
        productId: conversions.toDocumentReferenceId(source.productId),
        windowId: conversions.toDocumentReferenceId(source.windowId),
        externalId: source.externalId,
        promotionId: conversions.toDocumentReferenceId(source.promotionId),
        promoPrice: conversions.fromBigNumber(source.promoPrice),
        regularPrice: conversions.fromBigNumber(source.regularPrice),
        optRegularPrice: index_1.Utils.isValueMissing(source.optRegularPrice) ? null : conversions.fromBigNumber(source.optRegularPrice),
        cmForecast: index_1.Utils.isValueMissing(source.cmForecast) ? null : conversions.fromBigNumber(source.cmForecast),
        systemVolume: index_1.Utils.isValueMissing(source.systemVolume) ? null : conversions.fromBigNumber(source.systemVolume),
        lastSystemVolumeUpdate: index_1.Utils.isValueMissing(source.lastSystemVolumeUpdate) ? null : conversions.fromDate(source.lastSystemVolumeUpdate),
        promoVolume: conversions.fromBigNumber(source.promoVolume),
        regularVolume: index_1.Utils.isValueMissing(source.regularVolume) ? null : conversions.fromBigNumber(source.regularVolume),
        requestSecondaryPlacement: source.requestSecondaryPlacement,
        secondaryPlacement: source.secondaryPlacement,
        posAttributes: conversions.asObject(source, 'posAttributes', this.serializePosAttributes(conversions)),
        memberCredits: conversions.asObject(source, 'memberCredits', this.serializeMemberCredits(conversions)),
        logisticComment: source.logisticComment,
        returnable: source.returnable,
        returnableCondition: source.returnableCondition,
        endDateOfReturn: index_1.Utils.isValueMissing(source.endDateOfReturn) ? null : conversions.fromDate(source.endDateOfReturn),
        distrModelId: conversions.toDocumentReferenceId(source.distrModelId),
        lastDistrModelIdChangeTime: index_1.Utils.isValueMissing(source.lastDistrModelIdChangeTime) ? null : conversions.fromDate(source.lastDistrModelIdChangeTime),
        lastDistrModelIdChangeUser: index_1.Utils.isValueMissing(source.lastDistrModelIdChangeUser) ? null : this.userInfoConverter.toDocument(source.lastDistrModelIdChangeUser, conversions),
        distributionModelDays: source.distributionModelDays,
        lockType: source.lockType,
        selloutSales: source.selloutSales,
        ignoreForTraining: source.ignoreForTraining,
        activeSale: source.activeSale,
        extraSaleSticker: source.extraSaleSticker,
        tastings: source.tastings,
        tvCommercial: source.tvCommercial,
        groupOfSitesId: conversions.toDocumentReferenceId(source.groupOfSitesId),
        sitesData: conversions.asObject(source, 'sitesData', function (obj) {
          return _this3.windowItemSitesDataConverter.toDocument(obj, conversions);
        }),
        onPicture: source.onPicture,
        stateFlags: source.stateFlags.serialize(),
        classification: source.classification,
        warningFlags: source.warningFlags.serialize(),
        marketingComment: source.marketingComment,
        directDelivery: source.directDelivery,
        directDeliverySites: source.directDeliverySites,
        measureUnits: conversions.toDocumentReferenceId(source.measureUnits),
        simulation: conversions.asObjectOpt(source, 'simulation', this.serializeSimulation(conversions)),
        substituteProductId: source.substituteProductId === null ? null : conversions.toDocumentReferenceId(source.substituteProductId),
        justInTime: source.justInTime,
        processed: source.processed,
        lastPromoVolumeUpdate: index_1.Utils.isValueMissing(source.lastPromoVolumeUpdate) ? null : conversions.fromDate(source.lastPromoVolumeUpdate),
        lastSystemVolumeComputationFailure: index_1.Utils.isValueMissing(source.lastSystemVolumeComputationFailure) ? null : conversions.fromDate(source.lastSystemVolumeComputationFailure),
        forecastCoordinatorFlag: conversions.asObjectOpt(source, 'forecastCoordinatorFlag', this.serializeCoordinator(conversions)),
        snapshotOriginId: index_1.Utils.isValueMissing(source.snapshotOriginId) ? null : conversions.toDocumentReferenceId(source.snapshotOriginId),
        source: source.source
      });
      return result;
    }
  }, {
    key: "deserializeSimulation",
    value: function deserializeSimulation(conversions) {
      var _this4 = this;

      return function (document) {
        return index_1.Utils.isValueMissing(document) ? null : _this4.windowItemSimulationConverter.toObject(document, conversions);
      };
    }
  }, {
    key: "serializeSimulation",
    value: function serializeSimulation(conversions) {
      var _this5 = this;

      return function (object) {
        return index_1.Utils.isValueMissing(object) ? null : _this5.windowItemSimulationConverter.toDocument(object, conversions);
      };
    }
  }, {
    key: "deserializePosAttributes",
    value: function deserializePosAttributes(conversions) {
      var _this6 = this;

      return function (document) {
        return _this6.windowItemPosAttributesConverter.toObject(document, conversions);
      };
    }
  }, {
    key: "serializePosAttributes",
    value: function serializePosAttributes(conversions) {
      var _this7 = this;

      return function (object) {
        return _this7.windowItemPosAttributesConverter.toDocument(object, conversions);
      };
    }
  }, {
    key: "deserializeMemberCredits",
    value: function deserializeMemberCredits(conversions) {
      var _this8 = this;

      return function (document) {
        return _this8.memberCreditsConverter.toObject(document, conversions);
      };
    }
  }, {
    key: "serializeMemberCredits",
    value: function serializeMemberCredits(conversions) {
      var _this9 = this;

      return function (object) {
        return _this9.memberCreditsConverter.toDocument(object, conversions);
      };
    }
  }, {
    key: "deserializeCoordinator",
    value: function deserializeCoordinator(conversions) {
      var _this10 = this;

      return function (document) {
        return index_1.Utils.isValueMissing(document) ? null : _this10.coordinatorFlagsConverter.toObject(document, conversions);
      };
    }
  }, {
    key: "serializeCoordinator",
    value: function serializeCoordinator(conversions) {
      var _this11 = this;

      return function (object) {
        return index_1.Utils.isValueMissing(object) ? null : _this11.coordinatorFlagsConverter.toDocument(object, conversions);
      };
    }
  }]);

  return WindowItemConverterImpl;
}(WindowItemConverter_1.WindowItemConverter);

WindowItemConverterImpl = __decorate([__param(0, typescript_ioc_1.Inject), __param(1, typescript_ioc_1.Inject), __param(2, typescript_ioc_1.Inject), __param(3, typescript_ioc_1.Inject), __param(4, typescript_ioc_1.Inject), __param(5, typescript_ioc_1.Inject), __metadata("design:paramtypes", [WindowItemSimulationConverter_1.WindowItemSimulationConverter, WindowItemPosAttributesConverter_1.WindowItemPosAttributesConverter, WindowItemSitesDataConverter_1.WindowItemSitesDataConverter, MemberCreditsConverter_1.MemberCreditsConverter, UserInfoConverter_1.UserInfoConverter, CoordinatorFlagsConverter_1.CoordinatorFlagsConverter])], WindowItemConverterImpl);
exports.WindowItemConverterImpl = WindowItemConverterImpl;